<template>
  <div class="count-container">
    <div class="item icon_1">
      <span>累计出入车数 :</span>
      <ICountUp
          :delay="delay"
          :endVal="monthCarTS"
          @ready="(instance, CountUp) => onReady(instance, CountUp, monthCarTS)"
        />
    </div>
    <div class="item icon_2">
      <span>计费车辆数 :</span>
      <!-- <span> -->
        <ICountUp
          :delay="delay"
          :endVal="monthFee"
          @ready="(instance, CountUp) => onReady(instance, CountUp, monthFee)"
        />
      <!-- </span> -->
    </div>
    <div class="item icon_1">
      <span> 费用累计数: </span>
      <!-- <div> -->
        <ICountUp
          :delay="delay"
          :endVal="monthCarTA"
          @ready="(instance, CountUp) => onReady(instance, CountUp, monthCarTA)"
        />
      <!-- </div> -->
    </div>
    <!-- <div class="item"><span>年度累计:2000</span></div> -->
  </div>
</template>
<script>
import ICountUp from "vue-countup-v2";
export default {
  components: {
    ICountUp,
  },
  props: {
    monthCarTS: {
      type: Number,
    },
    monthCarTA: {
      type: Number,
    },
    monthFee: {
      type: Number,
    },
    carNumSumFees:{
      type:Array,
      default: function () {
        return [];
      },
    }
  },
  data() {
    return {
      delay: 2000,
    };
  },
  watch:{
  },
  methods: {
    onReady: (instance, CountUp, num) => {
      setTimeout(() => {
        instance.reset();
        instance.update(parseInt(num));
      }, 10000);
      // const that = this;
      // instance.update(that.endVal + 100);
    },
  },
};
</script>
<style scoped>
.count-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.item {
  width: 30%;
  height: 128px;
  font-size: 29px;
  color: #00f7ff;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.item span {
  display: block;
  line-height: 128px;
}
.item span:nth-child(1) {
  margin-left: 25%;
  letter-spacing:3px;
}
.item span:nth-child(2) {
  margin-left: 2%;
  letter-spacing:3px;
}
.icon_1 {
  background: url("~@/assets/images/count_1.png") no-repeat;
  background-size: 100% 100%;
}
.icon_2 {
  background: url("~@/assets/images/count_2.png") no-repeat;
  background-size: 100% 100%;
}
.icon_3 {
  background: url("~@/assets/images/count_1.png") no-repeat;
  background-size: 100% 100%;
}
.item span:first-child {
  margin-bottom: 5px;
}
</style>
